import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Refresh = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.9891 10.2627C3.9891 6.80438 6.68508 4.00056 10.0104 4.00056C11.9344 4.00056 13.6477 4.93904 14.7501 6.39999" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M2.49896 8.76702L4.02326 10.7898L6.04607 9.26553" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M16.0109 9.77637C16.0109 13.2347 13.3149 16.0385 9.98964 16.0385C8.06562 16.0385 6.35228 15.1 5.24995 13.6391" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M17.501 11.272L15.9767 9.24923L13.9539 10.7735" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default Refresh;